import { render, staticRenderFns } from "./autoinput.vue?vue&type=template&id=74aa0b3c&scoped=true&"
import script from "./autoinput.vue?vue&type=script&lang=js&"
export * from "./autoinput.vue?vue&type=script&lang=js&"
import style0 from "./autoinput.vue?vue&type=style&index=0&id=74aa0b3c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aa0b3c",
  null
  
)

export default component.exports